import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectErrorMessagesByKeyName } from "../../../reducers/reference_errormessages"


export const ValueLimitation_Root = (ValueLimitationSlice, Object, ObjectArray, ValueLimitationType, ValueLimitationMin, ValueLimitationMax,ErrorMess) => {
    
    const QS_Total = ErrorMess['VAL QS TOTAL VALUE']
    const QS_Between = ErrorMess['VAL QS SELECT BETWEEN']
    var ValueLimitationFlag = true
    var ValueLimitationErrorMessage = ''
    if (ValueLimitationSlice === 'QUESTION SET') {

        if (ValueLimitationType === "SUM") {
            ValueLimitationFlag = ValueLimitation_Sum(ObjectArray, ValueLimitationMin, ValueLimitationMax)
            ValueLimitationErrorMessage = QS_Total && QS_Total.length>0 && QS_Total[0].MessageTypeContent.replace('<<MAX>>',ValueLimitationMax).replace('<<MIN>>',ValueLimitationMin) || ''
        }
        else if (ValueLimitationType === "LIMIT YES ANSWER") {
            ValueLimitationFlag = ValueLimitation_LimitAnswer(ObjectArray, Object, ValueLimitationMin, ValueLimitationMax)
            ValueLimitationErrorMessage = QS_Between && QS_Between.length>0 && QS_Between[0].MessageTypeContent.replace('<<MAX>>',ValueLimitationMax).replace('<<MIN>>',ValueLimitationMin) || ''
        }
        else if (ValueLimitationType === "") {
            ValueLimitationFlag = true
            ValueLimitationErrorMessage=''
        }
    }

    return {ValueLimitationFlag, ValueLimitationErrorMessage}
}

export const ValueLimitation_Sum = (Questions, ValueLimitationMin, ValueLimitationMax) => {
    
    var sum = 0
    for (var q = 0; q < Questions.length; q++) {
        if (Questions[q].Responses && Questions[q].Responses.length > 0) {
            sum += parseFloat(Questions[q].Responses[0].Response ? Questions[q].Responses[0].Response : 0, 0)
    
        }
    }

    if (sum >= ValueLimitationMin && sum <= ValueLimitationMax) {
        return true
    } 
    return false
}

export const ValueLimitation_LimitAnswer = (Questions, Object, ValueLimitationMin, ValueLimitationMax) => {
    var sum = 0
    for (var q = 0; q < Questions.length; q++) {
        if (Questions[q].Responses && Questions[q].Responses.length > 0) {
            sum += Questions[q].Responses[0].Response === '42' ? 1 : 0
        }
    }

    if ((sum==0 && !Object.WasChanged) ||  (sum>= ValueLimitationMin && sum <= ValueLimitationMax)) {
        return true
    }

    return false
}

